export default __webpack_public_path__ + "static/media/887fa8c6d5afb19c449e6649a6be144f1602463512009.1fbefda2.webp";